import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'REQUEST_DRIVERS':
      return Object.assign({}, state, {
        loading: action.loading
      })
    case 'RECEIVE_DRIVERS':
      return Object.assign({}, state, {
        loading: action.loading,
        driverList: action.payload.data
      })
    default:
      return state
  }
}

export default reducer
